import {
  NUMBERS_CONNECTING,
  NUMBERS_DATA,
} from 'store/types';

const INITIALSTATE = {
  timestamp: null,
  loading: null,
  numbers: [],
  cids: [],
  cfList: [],
  phonenumbers: [],
};

export default function (state = INITIALSTATE, action) {
  switch (action.type) {
    case NUMBERS_CONNECTING:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: true
        })
      };
    case NUMBERS_DATA:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: false,
          ...action.payload
        })
      };
    default:
      return state;
  }
}
